import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import {
  HelpSidebarContainer,
  Header,
  IconImg,
  HeaderLeft,
  SearchContainer,
  Input,
  SearchIcon,
  HelpSidebarSmallContainer,
  CloseHelpBar,
  HelpOptionsContainer,
  Onboarding,
  OnboardingIcon,
  CloseImage,
} from './style';
import Accordion from './Accordion';
import { isSmallScreen } from '../../components/ReactiveRender';
import helpdata from './helpdata.json';
import { userRole } from '../../roles';
import helpbing from '../../static/img/help-icon.svg';
import onboarding from '../../static/icons/External _Link.svg';
import {
  HeadingImage,
  Heading,
} from '../../components/NotificationsMenu/NotificationsBar/style';
import { getUserRole } from '../../userLocalDetails';
import { useTour } from '../../TourContext';
import { AppContext } from '../../app.context';
import { useProfile } from '../../components/state/hooks';
import { isSchoolTeacherRole } from '../../utils/userAccessHelper.js';

const HelpSidebar = ({ onCloseFn }) => {
  const isSmallView = isSmallScreen();
  const role = userRole();
  const [data, setData] = useState(helpdata[role] || []);
  const [searchQuery, setSearchQuery] = useState('');
  const history = useHistory();
  const { setTourState, setTourRelaunchRequested } = useTour();
    const context = useContext(AppContext) || {};
    const { setShowTeacherOnboarding, startSimpleOnboarding } = context;
  const { data: profile } = useProfile();
  // The tour can be re-taken from the Help Centre by ANY teacher — new,
  // already-finished, or onboarded before the tour existed — plus students
  // (who get their own /student-onboarding path below).
  const showOnboardingEntry = true;

  const handleOnboardingButtonClick = () => {
    // Students (school + non-school) and non-school teachers relaunch the
    // simplified flow from the welcome carousel (App skips the state/year
    // collection on relaunch since they've already set it).
    if (getUserRole() === 'STUDENT' || !isSchoolTeacherRole(profile)) {
      if (startSimpleOnboarding) startSimpleOnboarding();
      if (onCloseFn) onCloseFn();
      return;
    }
    // School teacher: restart the welcome carousel from the beginning, which
    // then hands off to the setup-checklist hub. This is deliberately
    // NON-DESTRUCTIVE: we do NOT reset onboardingTasks / completedTours (that
    // would wipe a returning teacher's saved checklist via the debounced PATCH)
    // and we do NOT flip hasCompletedOnboarding. We clear any in-flight tour
    // flags, set the session-only relaunch flag so App.jsx's new-users-only
    // render gates allow the surface for existing teachers too, then show the
    // welcome carousel. It never auto-re-opens on a later login.
    setTourRelaunchRequested(true);
    setTourState({
      markingTourActive: false,
      draftTourActive: false,
      newTaskTourActive: false,
      feedbackTourActive: false,
      markingTourStep: 1,
      draftTourStep: 1,
      newTaskTourStep: 1,
      feedbackTourStep: 1,
      showOnboardingComplete: false,
    });
    history.push('/tasks');
    setShowTeacherOnboarding(true);
    if (onCloseFn) onCloseFn();
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    if (!query) {
      setData(helpdata[role]);
      return;
    }

    const filteredData = helpdata[role].filter(
      (section) =>
        section.title.toLowerCase().includes(query.toLowerCase()) ||
        section.subtopics.some((subtopic) =>
          subtopic.title.toLowerCase().includes(query.toLowerCase()),
        ),
    );

    setData(filteredData);
  };

  return isSmallView ? (
    <HelpSidebarSmallContainer>
      <CloseHelpBar src="/img/close.png" onClick={onCloseFn} />
      {helpSidebarContent(
        data,
        handleSearch,
        handleOnboardingButtonClick,
        onCloseFn,
        showOnboardingEntry,
      )}
    </HelpSidebarSmallContainer>
  ) : (
    <HelpSidebarContainer onClick={(e) => e.stopPropagation()}>
      {helpSidebarContent(
        data,
        handleSearch,
        handleOnboardingButtonClick,
        onCloseFn,
        showOnboardingEntry,
      )}
    </HelpSidebarContainer>
  );
};

export default HelpSidebar;

function helpSidebarContent(
  data,
  handleSearch,
  handleOnboardingButtonClick,
  onCloseFn,
  showOnboardingEntry,
) {
  return (
    <>
      <Header>
        <HeaderLeft>
          <HeadingImage src={helpbing} />
          <Heading>Help Centre</Heading>
        </HeaderLeft>
        <CloseImage src="img/closecircle.svg" onClick={onCloseFn} />
      </Header>
      <SearchContainer>
        <Input
          placeholder="Search for topics"
          onChange={(e) => handleSearch(e.target.value)}
        />
        <SearchIcon src="/img/find-replace.png" />
      </SearchContainer>
      <HelpOptionsContainer>
        {showOnboardingEntry && (
          <Onboarding onClick={handleOnboardingButtonClick}>
            <OnboardingIcon src={onboarding} />
            Onboarding
          </Onboarding>
        )}
        {data.map((section, index) => (
          <Accordion key={index} {...section} />
        ))}
      </HelpOptionsContainer>
    </>
  );
}
